import { Modal } from 'bootstrap'

document.addEventListener('turbo:load', () => {
  document.body.addEventListener('timer:expired', (event) => {
    const modalElement = document.getElementById('reservationExpiredModal')
    const linkElement = document.getElementById('rescheduleLink')
    if (!modalElement || !linkElement) {
      return
    }
    linkElement.href = event.detail.data?.new_url
    const modal = new Modal(modalElement)
    modal.show()
  })
})
